import React, { useEffect, useState } from "react";
import { getDocs, collection, doc, deleteDoc, orderBy, query } from 'firebase/firestore';
import { db, storage } from '../../firebase-config';
import { ref, deleteObject } from "firebase/storage";
import { useNavigate } from "react-router-dom";
import { isDOMComponent } from "react-dom/test-utils";
import styles from '../../Styles/homepage.css';
import SeePost from "../SeePost";

function HomePosts({isAuth}) {

    let navigate = useNavigate();
    var isShown = false;
    const [postsList, setPostLists] = useState([]);

    const postsCollectionRef = collection(db, "posts");
    const q = query(postsCollectionRef, orderBy("createdAt", "desc"));

    const getPosts = async () => {
        const data = await getDocs(q);
        setPostLists(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
    }

    const deletePost = async (id, filePathRef, imagePathRef) => {
        if(filePathRef != null)
        {
            deleteObject(ref(storage, filePathRef));
        }

        if(imagePathRef != null)
        {
            deleteObject(ref(storage, imagePathRef));
        }
        const postDoc = doc(db, "posts", id);
        await deleteDoc(postDoc);
        getPosts();
    }

    useEffect(() => {
        getPosts();
    }, []);

    return(
        <div className="homePage">
            {isAuth ?
            <div className="post">
                <div className="addPostBtnWrapper">
                    <a href="/createpost" className="black">
                        <button className="addPostBtn"> Dodaj post </button>
                    </a>
                </div>
            </div>
            : null}
            {postsList.map((post) => {
                return(
                    <div className="post">
                        <div className="postHeader">
                            <div className="title">
                                <h1 className="cutContent">{post.title}</h1>
                            </div>
                            <div className="deletePost">
                                {isAuth ? <button onClick={() => deletePost(post.id, post.PostFileLink, post.PostImageLink)}> <h5>Usuń post</h5> </button> : null}
                            </div>
                        </div>
                        <div className="postTextContainer">
                            <p className="cutContent">{post.postText}</p>
                        </div>
                        <div className="postAuthorContainer">
                            <p className="italia">{post.postAuthor}</p>
                        </div>
                        {post.postImageLink != "nolink" ?
                        <div className="postImageContainer">
                            {post.PostImageLink == null ? null : <img src={post.PostImageLink} className="postImage"/>}
                        </div>
                        : null}
                        {post.postFileLink != "nolink" ?
                        <div className="postFileContainer">
                            {post.PostFileLink == null ? null : <a href={post.PostFileLink} className="hrefText">{post.fileNameUpload}</a>}
                        </div>
                        : null}
                        <SeePost postTitlex={post.title} postText={post.postText} postImageLink={post.PostImageLink} postFileLink={post.PostFileLink} postFileName={post.fileNameUpload} postAuthor={post.postAuthor}/>
                    </div>
                );
            })}
        </div>
    );
}

export default HomePosts;
